export default {
  availableMarkets: {
    id: 'bo_seller-options-shipping-rule_drawer-available_markets',
    defaultMessage: 'Available markets',
  },
  freeMethodTimeMinimumReachedTitle: {
    id: 'bo_seller-options-shipping-rule_drawer-free_method_time_minimum_reached_title',
    defaultMessage:
      'Your paid shipping option must be at least 1 day faster than your free shipping option.',
  },
  freeMethodTimeMinimumReachedDescription: {
    id: 'bo_seller-options-shipping-rule_drawer-free_method_time_minimum_reached_description',
    defaultMessage:
      'You need to increase the shipping time of your free option if you want to add a paid option.',
  },
  errorPaidMethodTimeNotFastEnough: {
    id: 'bo_seller-options-shipping-rule_drawer-paid-method-time-not-fast-enough',
    defaultMessage:
      'Your paid shipping option must be at least 1 day faster than your free shipping option.',
  },
} as const
